import { Typography } from "antd";
import { JsonEditor, UpdateFunction } from "json-edit-react";
import { useEffect, useState } from "react";
import { SiteConfigurationInput } from "../../../../services/client";

const { Title, Text } = Typography;

type EditSiteConfigurationProps = {
  onChange: (data: SiteConfigurationInput) => void;
  initialData: object;
  validate: (data: object) => boolean | undefined;
};

export const EditSiteConfiguration: React.FC<EditSiteConfigurationProps> = ({
  onChange,
  initialData,
  validate,
}) => {
  const [dirtyData, setDirtyData] = useState<object | undefined>();

  const handleChange: UpdateFunction = (props) => {
    if (validate(props.newData as object)) {
      onChange(props.newData as SiteConfigurationInput);
    }
    return true;
  };

  useEffect(() => {
    setDirtyData(initialData);
  }, [initialData]);

  return (
    <div style={{ marginTop: "20px" }}>
      <Title level={4}>Parsed Configuration</Title>
      <Text type="secondary">
        Use the editor below the modify the configuration in case of validation
        errors.
      </Text>

      <pre style={{ background: "#f5f5f5", padding: "10px" }}>
        <JsonEditor
          data={dirtyData || initialData}
          onUpdate={handleChange}
          collapse={1}
          minWidth={500}
          setData={(data) => setDirtyData(data as object)}
        />
      </pre>
    </div>
  );
};
